const pagesIndividualHomeEn = {
  welcome: "Welcome",
  name: "{{name}}",
  greeting: {
    morning: "Good morning",
    afternoon: "Good afternoon",
    evening: "Good evening",
  },
  chat: {
    placeholder: "Get your business operation done",
    agent: "Agent",
  },
  myTasks: {
    title: "My Tasks",
    empty: "No tasks assigned",
  },
  myRequests: {
    title: "My Requests",
    empty: "No requests",
    tableHeaders: {
      requestType: "Request Type",
      requestDate: "Request Date",
      progress: "Progress",
      status: "Status",
    },
    status: {
      rejected: "Rejected",
      approved: "Approved",
      pending: "Pending",
    },
  },
  inquiry: {
    title: "Inquiry & Reference",
  },
  application: {
    title: "Request",
    categories: {
      laborCore: "Labor Core",
      contractorCore: "Contractor Core",
      itOperationCore: "IT Operation Core",
      gaOperationCore: "GA Operation Core",
    },
  },
  taskStatuses: {
    ongoing: "Ongoing",
  },
  nextTask: "Next Task",
  operationPackages: {
    emptyState: {
      allCompleted: "All completed",
      description:
        "Currently, there are no procedures that require attention. If a new procedure arises, it will be displayed on this page.",
    },
  },
  applicationOperationPackages: {
    title: "Submit",
    cores: {
      laborCore: "Labor Core",
      contractorCore: "Contractor Core",
      itOperationCore: "IT Operation Core",
      gaOperationCore: "GA Operation Core",
    },
  },
  approvalTray: {
    title: "Approval Tray",
    empty: "No approval tasks",
    tableHeaders: {
      approvalTask: "Approval Task",
      deadline: "Deadline",
      applicant: "Applicant",
      approvalFlow: "Approval Flow",
    },
    emptyState: {
      allCompleted: "All approvals completed",
      description:
        "Currently, there are no tasks that require approval. If a new approval task arises, it will be displayed here.",
    },
    status: {
      waitingApproval: "Waiting for approval",
    },
  },
};

export default pagesIndividualHomeEn;
